import { render } from "./ButtonOptions.vue?vue&type=template&id=c436d7e6"
import script from "./ButtonOptions.vue?vue&type=script&lang=js"
export * from "./ButtonOptions.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__